import { useApp } from '../context.js';
import { useCountdown } from '../hooks/useCountdown.js';

export default function PlannedDateCard() {
    const { clearPlannedDate, completePlannedDate, haptic, openInMaps, plannedDate, restaurants, setPlanDateForm, setPlanDateSearch, setShowPlanDateModal } = useApp();
    // The 1-second tick lives here, so only this card re-renders every second
    const dateCountdown = useCountdown(plannedDate);
    return (
        !plannedDate ? (
            <div
                className="bg-white/90 apple-card rounded-2xl shadow-md mb-4 overflow-hidden cursor-pointer"
                onClick={() => {
                    setShowPlanDateModal(true);
                    setPlanDateForm({ restaurantId: null, restaurantName: '', date: '', time: '', notes: '' });
                    setPlanDateSearch('');
                    haptic('light');
                }}
            >
                <div className="bg-gradient-to-r from-pink-400 via-rose-400 to-red-400 p-4 text-center">
                    <div className="text-2xl mb-1">💕</div>
                    <h3 className="text-white font-bold text-lg">Plan a Date Night</h3>
                    <p className="text-white/80 text-sm">Tap to plan your next restaurant date</p>
                </div>
            </div>
        ) : (
            <div className={`bg-white/90 apple-card rounded-2xl shadow-md mb-4 overflow-hidden ${dateCountdown && dateCountdown.days === 0 && !dateCountdown.passed ? 'countdown-pulse' : ''}`}>
                <div className="bg-gradient-to-r from-pink-400 via-rose-400 to-red-400 p-4 text-center relative">
                    <div className="text-2xl mb-1">💕</div>
                    <h3 className="text-white font-bold text-lg">Date Night</h3>
                    <p className="text-white/90 font-semibold">{plannedDate.restaurantName}</p>
                    <p className="text-white/70 text-xs mt-1">
                        {new Date(plannedDate.dateTime).toLocaleDateString('en-US', {
                            weekday: 'long', month: 'long', day: 'numeric'
                        })}
                        {' at '}
                        {new Date(plannedDate.dateTime).toLocaleTimeString('en-US', {
                            hour: 'numeric', minute: '2-digit'
                        })}
                    </p>
                </div>
                <div className="p-4">
                    {dateCountdown && !dateCountdown.passed ? (
                        <div className="grid grid-cols-4 gap-2 mb-3">
                            {[
                                { value: dateCountdown.days, label: 'Days' },
                                { value: dateCountdown.hours, label: 'Hours' },
                                { value: dateCountdown.minutes, label: 'Mins' },
                                { value: dateCountdown.seconds, label: 'Secs' }
                            ].map(({ value, label }) => (
                                <div key={label} className="text-center bg-gradient-to-b from-pink-50 to-rose-50 rounded-xl p-3">
                                    <div className="text-2xl font-bold text-rose-600">{value}</div>
                                    <div className="text-xs text-gray-500 font-medium">{label}</div>
                                </div>
                            ))}
                        </div>
                    ) : dateCountdown?.passed ? (
                        <div className="text-center py-3 bg-pink-50 rounded-xl mb-3">
                            <div className="text-lg font-bold text-rose-600 animate-pulse">
                                It's date time! 🥂
                            </div>
                        </div>
                    ) : null}
                    {plannedDate.notes && (
                        <p className="text-sm text-gray-600 italic text-center mb-3">
                            "{plannedDate.notes}"
                        </p>
                    )}
                    <div className="text-center text-xs text-gray-400 mb-3">
                        Planned by {plannedDate.plannedBy === 'doug' ? '💛 Doug' : '💖 Les'}
                    </div>
                    <div className="flex gap-2">
                        {(() => {
                            const addr = plannedDate.address || (plannedDate.restaurantId && restaurants.find(x => x.id === plannedDate.restaurantId)?.address);
                            return addr ? (
                                <button
                                    onClick={() => openInMaps(addr)}
                                    className="flex-1 bg-gradient-to-r from-green-400 to-emerald-500 text-white px-3 py-2.5 rounded-xl font-semibold text-sm apple-button"
                                >
                                    📍 Directions
                                </button>
                            ) : null;
                        })()}
                        <button
                            onClick={() => completePlannedDate()}
                            className="flex-1 bg-gradient-to-r from-pink-400 to-rose-500 text-white px-3 py-2.5 rounded-xl font-semibold text-sm apple-button"
                        >
                            ✓ Complete
                        </button>
                        <button
                            onClick={() => clearPlannedDate()}
                            className="bg-gray-200 text-gray-600 px-3 py-2.5 rounded-xl font-semibold text-sm apple-button"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            </div>
        )
    );
}
